export default Object.freeze({
  CLAIMS: 'claims',
  ELIGIBILITY: 'eligibilityproof',
  SERCAT: 'sercat',
  SNAP_AND_SEND: 'snap-and-send',
});
